import { render, staticRenderFns } from "./info2.vue?vue&type=template&id=3be6d504"
import script from "./info2.vue?vue&type=script&lang=js"
export * from "./info2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports